<!-- is button type -->
<!-- <button *ngIf="type==='button'" nzSize="default" nz-button nzType="primary" class="exclude-padding btn-filled group relative max-xl:w-full px-0 pb-[2px]" style="padding-top: 2px!important">
  <span class="relative w-[calc(100%-4px)] h-[100%] !flex items-center justify-center text-center rounded-lg leading-[100%] px-6 {{ theme === 'bg-white-grad-stop12' ? 'bg-white text-gray-900 group-hover:text-white group-hover:bg-transparent' : '' }}">
    <ng-content></ng-content>
  </span>
</button> -->

<!-- is link type -->
<a *ngIf="type==='link'" [routerLink]="link" [nzSize]="size" nz-button nzType="link" class="exclude-padding {{borderColor}} group relative max-xl:w-full !px-0 pb-[0.125rem] {{btnClass || ''}}" style="padding-top: 0.125rem!important">
  <span class="relative w-[calc(100%-4px)] h-[100%] !flex items-center justify-center text-center {{size==='small'?'rounded-[0.15rem]':size==='default'?'rounded-[0.4rem]':size==='large'?'rounded-[0.4rem]':'rounded-[0.4rem]'}} leading-[100%] px-6 {{parentBg}} {{btnTextColor}} group-hover:{{btnTextHoverColor}} group-hover:bg-transparent">
    <ng-content></ng-content>
  </span>
</a>
